import { render, staticRenderFns } from "./Widgets.vue?vue&type=template&id=00be591c&scoped=true"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"
import style0 from "./Widgets.vue?vue&type=style&index=0&id=00be591c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be591c",
  null
  
)

export default component.exports